var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.config_name"),
                  placeholderValue: _vm.$t("common.routing.config_name"),
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.host"),
                  placeholderValue: _vm.$t("common.routing.host"),
                },
                model: {
                  value: _vm.host,
                  callback: function ($$v) {
                    _vm.host = $$v
                  },
                  expression: "host",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.port"),
                  placeholderValue: _vm.$t("common.routing.port"),
                },
                model: {
                  value: _vm.port,
                  callback: function ($$v) {
                    _vm.port = $$v
                  },
                  expression: "port",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  maxLength: 512,
                  inputLabel: _vm.$t("common.routing.uri"),
                  placeholderValue: _vm.$t("common.routing.uri"),
                },
                model: {
                  value: _vm.uri,
                  callback: function ($$v) {
                    _vm.uri = $$v
                  },
                  expression: "uri",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.login"),
                  placeholderValue: _vm.$t("common.routing.login"),
                },
                model: {
                  value: _vm.login,
                  callback: function ($$v) {
                    _vm.login = $$v
                  },
                  expression: "login",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.password"),
                  placeholderValue: _vm.$t("common.routing.password"),
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.timeout"),
                  placeholderValue: _vm.$t("common.routing.timeout"),
                },
                model: {
                  value: _vm.timeout,
                  callback: function ($$v) {
                    _vm.timeout = $$v
                  },
                  expression: "timeout",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.connect_timeout"),
                  placeholderValue: _vm.$t("common.routing.connect_timeout"),
                },
                model: {
                  value: _vm.connectTimeout,
                  callback: function ($$v) {
                    _vm.connectTimeout = $$v
                  },
                  expression: "connectTimeout",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formatName !== "" && _vm.formatOutName !== ""
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      "input-value": _vm.formatName,
                      inputLabel: _vm.$t("common.routing.format_name"),
                      placeholderValue: _vm.$t("common.routing.format_name"),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatName !== "" && _vm.formatOutName !== ""
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      "input-value": _vm.formatOutName,
                      inputLabel: _vm.$t("common.routing.format_out_name"),
                      placeholderValue: _vm.$t(
                        "common.routing.format_out_name"
                      ),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
            _c("label", { attrs: { for: "ssl-active" } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("common.routing.ssl_active"))
              ),
              _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sslActive,
                    expression: "sslActive",
                  },
                ],
                staticClass: "form-control",
                attrs: { disabled: _vm.readonly, id: "ssl-active" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.sslActive = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-read-group-label-input", {
                attrs: {
                  "input-value":
                    _vm.sslActive === "1"
                      ? _vm.$t("common.routing.ftps")
                      : _vm.$t("common.routing.sftp"),
                  inputLabel: _vm.$t("common.routing.type"),
                  placeholderValue: _vm.$t("common.routing.type"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.sslActive === "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "keystore-type" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.keystore"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keystore,
                        expression: "keystore",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "keystore-type" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.keystore = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "", hidden: "", disabled: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("common.routing.select_keystore_type")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.keystoreList, function (keystore) {
                      return _c(
                        "option",
                        { key: keystore.id, domProps: { value: keystore.id } },
                        [_vm._v(" " + _vm._s(keystore.name) + " ")]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive === "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "certificat-type" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.routing.certificat")) +
                      "\n"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ca,
                        expression: "ca",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "certificat-type" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.ca = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "", hidden: "", disabled: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("common.routing.select_certificat_type")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.caList, function (ca) {
                      return _c(
                        "option",
                        { key: ca.id, domProps: { value: ca.id } },
                        [_vm._v(" " + _vm._s(ca.name) + " ")]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive === "0"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "ssh-type" } }, [
                  _vm._v("\n          " + _vm._s(_vm.$t("common.routing.ssh"))),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ssh,
                        expression: "ssh",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "ssh-type" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.ssh = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "", hidden: "", disabled: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.select_ssh_type")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.sshList, function (ssh) {
                      return _c(
                        "option",
                        { key: ssh.id, domProps: { value: ssh.id } },
                        [_vm._v(" " + _vm._s(ssh.name) + " ")]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.sslActive === "1"
        ? _c("level-control-form", {
            attrs: {
              mode: _vm.mode,
              readonly: _vm.readonly,
              placementLevel: _vm.placementFTP,
            },
            model: {
              value: _vm.controlConfig,
              callback: function ($$v) {
                _vm.controlConfig = $$v
              },
              expression: "controlConfig",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.entitiesType === "rvm"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.vop_provider.vop_provider"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { attrs: { for: "vopProvider" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.vop_provider.name")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.IdVopProvider,
                              expression: "IdVopProvider",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: _vm.readonly, id: "vopProvider" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.IdVopProvider = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "", hidden: "", disabled: "" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.select_name_vop_provider"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.vopProviderList, function (vopProvider) {
                            return _c(
                              "option",
                              {
                                key: vopProvider.id,
                                domProps: { value: vopProvider.id },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(vopProvider.text) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }